import { Tooltip } from './Tooltip';
const RadioButton = ({
    label,
    field,
    isRequired = true,
    catalog,
    value = '',
    onChange,
    onChangeStr = () => { },
    readonly  = false,
    useToolTip = false,
    textToolTip = '',
    titleToolTip = '',
}: IPropsRadioButton) => {

    const IsChekedValue = (valueRadio: string) => (valueRadio === value);
    const ChangeCbo = (event: any) => onChangeStr(event.target.name, event.target.value);

    return (
        <>
            <div className='mt-10 mb-5 lbl-input-radio-auto-cr-emi'  style={{ display: "flex" }}>
                <span> {label}{isRequired && label.length > 0 && <span style={{ color: '#FF5F49' }}>*</span>} </span>
                {useToolTip && <Tooltip id={field} key={field} text={textToolTip} title={titleToolTip} />}
            </div>
            <div>
                {catalog?.map((x: ICatalog, index: number) => {
                    return (
                        <div key={`radio_${field}_${x.value}`} className='radio-auto-cr'>
                            <input key={`id_${field}_${x.value}`} id={`id_${field}_${index}`} type='radio' name={field} value={x.value} checked={IsChekedValue(x.value)} onChange={ChangeCbo} required={isRequired} disabled={readonly} />
                            <label key={`lbl_${field}_${x.value}`} className='lbl-input-radio-auto-cr2-emi' htmlFor={`id_${field}_${index}`}>{x.text}</label>
                        </div>
                    )
                })}
            </div>
        </>
    )
}

export { RadioButton };